// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"CustomMenu_ProseMirror__pjpLI","customMenu":"CustomMenu_customMenu__3DnyU"};